import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import {
  Typography,
  makeStyles, Box
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { IntegrationDots, IntegrationDotsProps } from '../../ui/integrationDots'
import { BootstrapInput } from '../../../../components/BootstrapInput'
import { useFormStyles } from '../../lib/hooks/useFormStyles'
import { DifferenceTooltip } from '../differenceTooltip'
import { HelpTooltip } from '../helpTooltip'

interface Option {
  value: string | number

  label: string
}

interface FormAutoselectProps extends IntegrationDotsProps {
  name: string

  label: string

  options: Option[]

  required?: boolean

  disabled?: boolean

  placeholder?: string

  marketplaceValue?: string

  description?: string
}

export const FormAutoselect = ({
                                 name,
                                 label,
                                 options,
                                 placeholder,
                                 types,
                                 required,
                                 disabled,
                                 marketplaceValue,
                                 description
                               }: FormAutoselectProps) => {
  const classes = useStyles()

  const formClasses = useFormStyles()

  const {control} = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      rules={{required: required ? 'Это поле обязательно' : false}}
      render={({field, fieldState}) => (
        <div>
          <div className={classes.root}>
            <Typography variant="subtitle1" className={classes.label}>
              {label}
            </Typography>
            <Box className={formClasses.dotsContainer}>
              <IntegrationDots types={types}/>
              {description && <HelpTooltip title={description} />}
              {marketplaceValue && <DifferenceTooltip title={marketplaceValue}/>}
            </Box>
          </div>
          <Autocomplete
            options={options}
            getOptionLabel={(option) => option.label}
            value={options.find(opt => opt.value === field.value) || null}
            onChange={(_, selected) => {
              field.onChange(selected?.value ?? '')
            }}
            disableClearable={required}
            disabled={disabled}
            renderInput={(props) => {
              const {InputProps, InputLabelProps /* ignored */, ...passProps} = props

              return <BootstrapInput
                {...passProps}
                {...InputProps}
                placeholder={placeholder}
                error={!!fieldState.error}
                fullWidth
                className={formClasses.autoselect}
              />
            }
            }
          />
        </div>
      )}
    />
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  label: {
    fontWeight: 500,
    fontSize: 14,
  }
}))